module.exports = __webpack_public_path__ + "static/media/infulzdesk.430e599d.webp";